import { useCallback } from 'react';

import { Table } from '@tanstack/react-table';

import Button from '@/components/Buttons/Button';
import useSelectionFunctions from '@/hooks/useSelectionFunctions';
import { CatalogItem } from '@/pages/Catalog/types';
import { parseForwardCurveRowToSymbol } from '@/pages/Catalog/utils/parseForwardCurveRowToSymbol';
import { SelectedSymbol } from '@/types/symbols';

const SelectAllButton = ({
  table,
  isForwardCurves
}: {
  table: Table<CatalogItem>;
  isForwardCurves: boolean;
}) => {
  const getFwdCurveSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => parseForwardCurveRowToSymbol(row));
  }, [table]);
  const getSpotSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => {
      return row.getValue<SelectedSymbol>('Symbol');
    });
  }, [table]);
  const { addAllSymbolsToSelection } = useSelectionFunctions();
  const disabled = table.getRowModel().rows.length > 30;
  return (
    <Button
      disabled={disabled}
      sx={{
        color: 'primary.main',
        ml: 1,
        px: 0.5,
        fontSize: 14,
        '&.Mui-disabled': {
          color: 'primary.main'
        }
      }}
      variant='text'
      onClick={() => {
        addAllSymbolsToSelection(isForwardCurves ? getFwdCurveSymbols() : getSpotSymbols());
      }}
    >
      Select All
    </Button>
  );
};
export default SelectAllButton;
